import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Row,
  Typography,
  Button,
  Input,
  Spin,
  Form,
} from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { onError } from 'utils/handlers';
import { solicitarRestablecerContrasena } from 'api/usuarios/auth';
import Card from './components/Card';
import './index.scss';

const { Title } = Typography;

const ForgotPassword = () => {
  const history = useHistory();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue();
      setLoading(true);
      const response = await solicitarRestablecerContrasena(values);
      if (response) {
        setTimeout(() => {
          history.push(`recuperacion-de-contrasena?email=${values.email}`);
        }, 300);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const rules = {
    email: [
      { type: 'email' },
      { required: true },
    ],
  };

  return (
    <Spin tip="Loading..." spinning={loading}>
      <Card>
        <Row style={{ width: '100%' }}>
          <Button
            type="link"
            className="auth-button"
            style={{ textAlign: 'left', padding: 0 }}
            onClick={() => history.push('/')}
          >
            <LeftOutlined />
            {' '}
            Volver
          </Button>
        </Row>
        <Title style={{ fontWeight: 'bold' }} level={3}>
          Recuperar contraseña
        </Title>
        <Form
          name="forgot-pwd-form"
          layout="vertical"
          form={form}
          onFinish={onFinish}
        >
          <Form.Item
            name="email"
            rules={rules.email}
            label="Correo electrónico"
            hasFeedback
          >
            <Input allowClear />
          </Form.Item>

          <Form.Item style={{ marginBottom: 0 }}>
            <Button
              htmlType="submit"
              shape="round"
              className="auth-button"
              block
            >
              Recuperar
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </Spin>
  );
};

export default ForgotPassword;
